import React, { useCallback, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import GridItem from "../../../components/Grid/GridItem.js";
import GridContainer from "../../../components/Grid/GridContainer.js";
import Button from "../../../components/CustomButtons/Button.js";
import { useHistory, useLocation } from "react-router-dom";
import { controlLabelColor, primaryIconColor, primaryColor } from "../../../style.scss";
import { loginToApp } from "../../../redux-services/actions/actions";
import { connect } from "react-redux";
import themeStyle from "../../../assets/jss/eclipse/components/themeStyle.js";
import { ReactComponent as CircleTickOutline } from "../../../assets/img/circle_tick_outline.svg"
import { ReactComponent as Thumbsup } from "../../../assets/img/thumbs_up.svg"
import ThumbsUpDemo from "../../../assets/img/Thumbs-up-selfie-image-in-app.jpg"
import AWSLiveness from "../../../assets/img/aws-liveness.svg"
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { DocumentType } from "../../../eclipse-react-sdk/services/models";
import { DCustomerManagementApi, GDocumentManagementApi } from "eclipse-react-sdk/services";
import { SpinnerComponent } from "react-element-spinner";
import AlertNotification from "../../../components/Snackbar/AlertNotification.js";
import { ToBinary } from "../../../utils.js";


const useStyles = makeStyles(themeStyle);

export function PhotoInitial(props) {
  const appState = props?.appData;
  const pageState = useLocation()?.state || appState?.pageState;
  const sessionId = pageState?.sessionId;
  const docData = pageState?.docData;
  const query = new URLSearchParams(window?.location?.search);
  const awsLivenessStatus = query.get('status');
  const classes = useStyles();
  const history = useHistory();
  const tenantId = appState?.auth?.tenantId;
  const customerId = appState?.customer?.customerId;
  const awsLivenessRatifyProcessor = appState?.template?.pwaAppOptions?.AWSLivenessRatifyProcessor || false;
  const selectedDocument = pageState?.selectedDoc;
  const document = pageState?.document;
  const fromScreen = pageState?.fromScreen;
  const isAddressAdded = pageState?.isAddressAdded;
  const idDocument = pageState?.idDocument;
  const idDocumentBack = pageState?.idDocumentBack;
  const idDocumentImageData = pageState?.idDocumentImageData;
  const idDocumentBackImageData = pageState?.idDocumentBackImageData;
  const selfieDocument = appState?.documents ? appState?.documents.find(doc => doc?.documentType === DocumentType.FACIALPHOTO) : null;
  const [selfieDocumentImageData, setSelfieDocumentImageData] = useState(null);
  const [alertData, setAlert] = useState(null);
  const [loading, setLoading] = React.useState(false);

  const redirectToErrorScreen = useCallback((fromScreen, toScreen) => {
    history.push({
      pathname: toScreen,
      state: { fromScreen }
    });
  }, [history]);

  const showAlert = useCallback((alertDisplay, alertType, message) => {
    setAlert({ isAlertDisplay: alertDisplay, alertType: alertType, alertMessage: message })
    setTimeout(() => {
      setAlert(null);
    }, 3000);
  }, []);

  const getAWSLivenessToken = useCallback(() => {
    setLoading(true);
    const newDocumentAPI = new DCustomerManagementApi();
    const landingUrl = `${window.location.origin}${process.env.PUBLIC_URL}/pages/selfie-initial`;
    const extraInfoObj = { landingUrl };
    const docRequestBody = {
      base64EncodedDocument: "AWS_LIVENESS_CHECK",
      documentType: DocumentType?.FACIALPHOTO,
      mediaType: "aws/liveness",
      extraInfo: JSON.stringify(extraInfoObj)
    }
    newDocumentAPI.tenantsTenantIdCustomersCustomerIdDocumentsPost(tenantId, customerId, docRequestBody, false).then((newDocumentAPIResponse) => {
      const extraInfoData = JSON.parse(newDocumentAPIResponse?.data?.extraInfo);
      const sessionId = extraInfoData?.awsLivenessSessionId;
      const completionUrl = extraInfoData?.completionUrl;
      const docData = newDocumentAPIResponse?.data;
      window.localStorage.setItem('appstate', btoa(ToBinary(JSON.stringify({ ...appState, pageState: { ...pageState, sessionId, docData } }))));
      window.location.replace(`${completionUrl}`);
    }).catch((error) => {
      if (error instanceof Error && error.response && error.response.data && error.response.data.length > 0 && error.response.data[0].description) {
        showAlert(true, 'ERROR', `${error.response.data[0].code} :: ${error.response.data[0].description}`);
      } else {
        redirectToErrorScreen('/auth/login', '/auth/error');
      }
    });
  }, [appState, customerId, tenantId, redirectToErrorScreen, showAlert, pageState]);

  const completedSelfieLivenessAnalysis = useCallback(async () => {
    const documentAPI = new GDocumentManagementApi();
    const responseDocumentPutCall = await documentAPI.tenantsTenantIdDocumentsDocumentIdPut(tenantId, docData?.documentId, docData, null, true).then((response) => {
      return response;
    });

    if (responseDocumentPutCall && !responseDocumentPutCall?.error) {
      const newDocumentAPI = new DCustomerManagementApi();
      const ratifyRequestBody = {
        type: "NORMAL"
      }
      return newDocumentAPI.tenantsTenantIdCustomersCustomerIdRatifyPost(tenantId, customerId, ratifyRequestBody).then((newDocumentAPIResponse) => {
        return newDocumentAPIResponse?.data;
      }).catch((error) => {
        if (error instanceof Error && error.response && error.response.data && error.response.data.length > 0 && error.response.data[0].description) {
          return { error: error.response.data[0].description };
        } else {
          return { error: `Something went wrong. Please try again` };
        }
      });
    } else {
      return { error: `Something went wrong. Please try again` };
    }
  }, [customerId, tenantId, docData]);

  const goToScanPhoto = useCallback(async () => {
    let pathname = `/pages/scan-selfie`;
    if (selfieDocumentImageData) {
      pathname = `/pages/upload-selfie`;
    }
    if (awsLivenessRatifyProcessor) {
      if (awsLivenessStatus && awsLivenessStatus === 'COMPLETED' && sessionId) {
        setLoading(true);
        const response = await completedSelfieLivenessAnalysis();
        if (response && !response?.selfieIsLegitimate?.passed) {
          delete appState.pageState.sessionId;
          props.photoInitialHandler({ ...appState });
          setLoading(false);
          showAlert(true, 'ERROR', `${response?.selfieIsLegitimate?.score
            ? `AWS Liveness has failed. Face Liveness score is : ${response?.selfieIsLegitimate?.score}. Please try again`
            : `Something went wrong. Please try again`}`);
          return;
        }
        delete appState.pageState;
        props.photoInitialHandler({ ...appState });
        pathname = `/pages/personal-information`;

        history.push({
          pathname,
          state: {
            isAddressAdded,
            fromScreen,
            selectedDoc: selectedDocument,
            document,
            idDocument,
            idDocumentBack,
            selfieDocument,
            idDocumentImageData,
            idDocumentBackImageData,
            selfieDocumentImageData
          },
        });
      } else {
        if (!awsLivenessStatus || awsLivenessStatus === 'CANCELLED' || (awsLivenessStatus === 'COMPLETED' && !sessionId)) {
          getAWSLivenessToken();
          return;
        }
      }
    } else {
      history.push({
        pathname,
        state: {
          isAddressAdded,
          fromScreen,
          selectedDoc: selectedDocument,
          document,
          idDocument,
          idDocumentBack,
          selfieDocument,
          idDocumentImageData,
          idDocumentBackImageData,
          selfieDocumentImageData
        },
      });
    }
  }, [awsLivenessRatifyProcessor, awsLivenessStatus, document, fromScreen, getAWSLivenessToken, history, idDocument, idDocumentBack, idDocumentBackImageData, idDocumentImageData, isAddressAdded, selectedDocument, selfieDocument, selfieDocumentImageData, completedSelfieLivenessAnalysis, showAlert, props, appState, sessionId]);

  const backToHome = useCallback(() => {
    history.push({
      pathname: `/pages/upload-document`,
      state: {
        isAddressAdded,
        fromScreen,
        selectedDoc: selectedDocument,
        document,
        idDocument,
        idDocumentBack,
        selfieDocument,
        idDocumentImageData,
        idDocumentBackImageData,
        selfieDocumentImageData
      },
    });
  }, [history, isAddressAdded, fromScreen, selectedDocument, document, idDocument, idDocumentBack, selfieDocument, idDocumentImageData, selfieDocumentImageData, idDocumentBackImageData]);

  React.useEffect(() => {
    window.onpopstate = () => {
      backToHome();
    };
  }, [history, backToHome, fromScreen])

  React.useEffect(() => {
    if (selfieDocument && selfieDocument?.mediaType && selfieDocument?.base64EncodedDocument && fromScreen !== 'ASSISTED_SIGNUP') {
      setSelfieDocumentImageData(`data:${selfieDocument?.mediaType};base64,${selfieDocument?.base64EncodedDocument}`);
    }
  }, [selfieDocument, setSelfieDocumentImageData, fromScreen]);

  React.useEffect(() => {
    if (awsLivenessStatus === 'COMPLETED' && appState?.pageState
      && appState?.pageState?.sessionId && appState?.pageState?.docData) {
      goToScanPhoto();
      return;
    }
  }, [awsLivenessStatus, goToScanPhoto, appState])

  return (
    <div>
      <SpinnerComponent loading={loading} position="global" color={primaryColor} />
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div className={'progress-bar'}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <p onClick={() => {
                backToHome()
              }} style={{ display: 'flex', alignItems: 'center', fontSize: 18 }}>
                <ArrowBackIosIcon />
                <span>{"Back"}</span>
              </p>
              <small style={{
                color: controlLabelColor,
                marginLeft: "auto"
              }}>Step {fromScreen === 'ASSISTED_SIGNUP' ? 4 : 3} of 5</small>
            </div>
            <strong><small style={fromScreen === 'ASSISTED_SIGNUP' ? { width: '80%' } : { width: '60%' }}>&nbsp;</small></strong>
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <h1 className='auth-title'
            dangerouslySetInnerHTML={{ __html: fromScreen === 'ASSISTED_SIGNUP' ? 'Upload their <br /> photo.' : awsLivenessRatifyProcessor ? `Let's check that <br /> you are human` : 'Upload your <br /> selfie.' }} />
          <p className={classes.regularFontSize + ' m-b-0'}>
            <strong>{fromScreen === 'ASSISTED_SIGNUP' ? 'Take a close-up photo of their face with a thumbsup to verify their identity.' : awsLivenessRatifyProcessor ? `Next, we’ll confirm that you are who you say you are by using your device's camera. You will need to follow the steps below:` : 'Please take a selfie with a thumbsup close to your face.'}</strong>
          </p>
        </GridItem>
        {awsLivenessRatifyProcessor ?
          <>
            <GridItem xs={12} sm={12} md={12}>
              <p className={classes.regularFontSize + ' ' + classes.textCenter + ' m-t-0'}>
                <strong>See the example below.</strong>
              </p>
              <span style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                <img src={AWSLiveness} alt="" />
              </span>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <p className={classes.regularFontSize} style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'inherit' }}>
                <strong style={{ margin: '0 10px 0 0' }}><CircleTickOutline fill={primaryIconColor} stroke={primaryIconColor} /></strong>
                Position your face to fit into the oval shape
              </p>
              <p className={classes.regularFontSize} style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'inherit' }}>
                <strong style={{ margin: '0 10px 0 0' }}><CircleTickOutline fill={primaryIconColor} stroke={primaryIconColor} /></strong>
                Click the button to start recording a video
              </p>
              <p className={classes.regularFontSize} style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'inherit' }}>
                <strong style={{ margin: '0 10px 0 0' }}><CircleTickOutline fill={primaryIconColor} stroke={primaryIconColor} /></strong>
                Follow the on-screen instructions to guide you to complete the process
              </p>
            </GridItem>
          </>
          :
          <>
            <GridItem xs={12} sm={12} md={12}>
              <p className={classes.regularFontSize}
                style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'inherit' }}><strong
                  style={{ margin: '0 10px 0 0' }}><CircleTickOutline fill={primaryIconColor}
                    stroke={primaryIconColor} /></strong> {fromScreen === 'ASSISTED_SIGNUP' ? 'Let them stand in front of a plain, light-coloured wall.' : 'Stand in front of a plain, light-coloured wall.'}
              </p>
              {fromScreen === 'ASSISTED_SIGNUP' ?
                <p className={classes.regularFontSize} style={{ display: 'table' }}><strong
                  style={{ padding: '0 10px 0 0', display: 'table-cell', verticalAlign: 'top' }}><CircleTickOutline
                    fill={primaryIconColor} stroke={primaryIconColor} /></strong> Ask them to give a thumbs
                  up <Thumbsup style={{ margin: '-6px 0 0 0', verticalAlign: 'middle' }} fill={primaryIconColor}
                    stroke={primaryIconColor} /> close to their face.</p>
                :
                <p className={classes.regularFontSize}
                  style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'inherit' }}><strong
                    style={{ margin: '0 10px 0 0' }}><CircleTickOutline fill={primaryIconColor}
                      stroke={primaryIconColor} /></strong> Give a
                  thumbs up <Thumbsup style={{ margin: '-6px 0 0 0' }} fill={primaryIconColor}
                    stroke={primaryIconColor} /> close to your face.</p>
              }
              <p className={classes.regularFontSize}
                style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'inherit' }}><strong
                  style={{ margin: '0 10px 0 0' }}><CircleTickOutline fill={primaryIconColor}
                    stroke={primaryIconColor} /></strong> {fromScreen === 'ASSISTED_SIGNUP' ? 'Check that their face and thumb are in focus and not blurry.' : 'Check that your face and thumb are in focus and not blurry.'}
              </p>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <p className={classes.regularFontSize + ' ' + classes.textCenter + ' m-t-0'}><strong>See the example
                below.</strong></p>
              <span style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}><img src={ThumbsUpDemo}
                alt="" /></span>
            </GridItem>
          </>
        }
        <GridItem xs={12} sm={12} md={12}>
          <Button className={classes.buttonRadius} size="lg" block color="primary" type="submit"
            onClick={goToScanPhoto}>Let's do it</Button>
        </GridItem>
      </GridContainer>
      {alertData?.isAlertDisplay ? <AlertNotification alertData={alertData} /> : null}
    </div>
  );
}

const mapStateToProps = state => ({
  appData: state.applicationData.appData
})

const mapDispatchToProps = dispatch => ({
  photoInitialHandler: data => dispatch(loginToApp(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(PhotoInitial)
